export const ZLICK_GET_SUBSCRIPTIONS = 'ZLICK_GET_SUBSCRIPTIONS'
